var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('mu-drawer', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "close": _vm.toggleNav
    }
  }, [_c('mu-appbar', [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('mu-list', {
    attrs: {
      "value": _vm.menuVal
    },
    on: {
      "change": _vm.handleMenuChange
    }
  }, _vm._l((_vm.navConfig), function(nav) {
    return _c('mu-list-item', {
      key: nav.title,
      attrs: {
        "title": nav.title,
        "open": true,
        "toggleNested": ""
      }
    }, _vm._l((nav.list), function(item) {
      return _c('mu-list-item', {
        key: item.title,
        attrs: {
          "value": item.path,
          "title": item.title
        },
        slot: "nested"
      })
    }))
  }))], 1), _vm._v(" "), _c('mu-appbar', {
    staticClass: "example-appbar",
    class: {
      'nav-hide': !_vm.open
    },
    attrs: {
      "title": _vm.title
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "menu"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "href": "https://github.com/museui/muse-ui",
      "icon": ":mudocs-icon-custom-github"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-content",
    class: {
      'nav-hide': !_vm.open
    }
  }, [_vm._t("default")], 2)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4f796548", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-4f796548","hasScoped":false}!./node_modules/.13.0.4@vue-loader/lib/selector.js?type=template&index=0!./example/components/layout/layout.vue
// module id = 248
// module chunks = 5